// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1huZT","alertIcon":"ConfirmModal_alertIcon__1R-w9"};